import { FunctionComponent } from "react";
import styled from "styled-components";
import Image from "next/image";

import MarketingLink from "../../MarketingLink";
import { Device } from "@/utils/device";

const copy =
  "We support women at every stage of their journey, and that's why our digital platform offers a wealth of courses, workshops, and series to arm you with the tools you need to achieve your ambitions, whatever they may be.";

const CoursesForAllContent: FunctionComponent = () => {
  return (
    <S.Section>
      <S.TextContent>
        <S.Title>
          <S.BoldWrap>Courses</S.BoldWrap>
          <S.SmallWrap>for all ages</S.SmallWrap>
          at all stages
        </S.Title>
        <S.Copy>{copy}</S.Copy>
        <MarketingLink
          href="/memberships/virtual"
          linkText="Virtual membership"
          textColour="#0B0B29"
          colour="#0B0B29"
        />
      </S.TextContent>
      <S.ImageContainer>
        <Image
          src="/images/marketing/woman-yellow-background.png"
          alt=""
          layout="fill"
          objectFit="cover"
          objectPosition="right"
        />
      </S.ImageContainer>
    </S.Section>
  );
};

const S = () => {};

S.Section = styled.section`
  background: linear-gradient(180deg, #fecc66 0%, #eda338 100%);
  color: #0b0b29;
  display: flex;
  flex-direction: column;
  align-content: center;

  @media (min-width: 620px) {
    background-color: #53578a;
    background-image: url("/images/marketing/woman-yellow-background.png");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: right;
  }
`;

S.TextContent = styled.div`
  padding: 10%;

  @media (min-width: 620px) {
    width: 60vw;
  }

  @media (min-width: ${Device.tablet}) {
    padding: 8% 10%;
  }
`;

S.Title = styled.h2`
  font-family:
    Roxborough CF,
    sans-serif;
  font-size: 6rem;
  font-weight: 100;
  line-height: 5.5rem;
  margin-bottom: 4rem;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;

  @media (min-width: ${Device.tablet}) {
    font-size: 7rem;
    line-height: 6rem;
  }

  @media (min-width: ${Device.desktop}) {
    font-size: 8rem;
  }
`;

S.BoldWrap = styled.span`
  font-family:
    HK Grotesk,
    sans-serif;
  font-weight: 800;
  letter-spacing: -2px;
  line-height: 3.5rem;
`;

S.SmallWrap = styled.span`
  font-style: italic;
  font-size: 4rem;
  align-self: flex-end;

  @media (min-width: ${Device.mobile}) {
    align-self: center;
  }
`;

S.Copy = styled.p`
  padding: 1rem 0 4rem 0;

  @media (min-width: ${Device.tablet}) {
    padding: 2rem 0 5rem 0;
    font-size: 1.8rem;
  }

  @media (min-width: ${Device.desktop}) {
    padding: 3rem 0 6rem 0;
    font-size: 2rem;
  }
`;

S.ImageContainer = styled.div`
  position: relative;
  height: 35rem;
  width: 100%;

  @media (min-width: ${Device.mobile}) {
    height: 45rem;
  }

  @media (min-width: 620px) {
    display: none;
  }
`;

export default CoursesForAllContent;
